import api from '../../lib/api';
import changePage from "../Register/changePage";


export const updateRegistration = data =>
    function get(dispatch) {
        api
            .sendPost(`/clients/register/${data.hash}/${data.client_id}`, data, (error, response) => {
                if (error) return console.error(error);
                // if (response.data.hash) {
                //   return dispatch(updateRegError(response.data));
                // }
                return dispatch(updateRegSuccess(response.data));
            });
    };

export const checkRegistration = data =>
    function get(dispatch) {
        api
            .sendPost(`/clients/check-client`, data, (error, response) => {
                if (error) return console.error(error);
                console.log(response);
                console.log(response.data);
                if (response.data.exists === true) {
                    return dispatch(changePage(11));
                } else {
                    return dispatch(changePage(4));
                }
            });
    };

export const updatePathway = data =>
    function get(dispatch) {
        api.sendPut(`/public-dashboard/register/pathways`, data, (error, response) => {
        })
    };


export const updateRegSuccess = data => ({
    type: 'UPDATE_CLIENT_REGISTRATION_SUCCESS',
    data,
});

export const updateRegError = data => ({
    type: 'UPDATE_CLIENT_REGISTRATION_ERROR',
    data,
});



// WEBPACK FOOTER //
// ./src/Actions/Password/register.js